'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cwUi = require('cw-ui');

var _CwRouter = require('../../components/cwrouter/CwRouter');

var _CwRouter2 = _interopRequireDefault(_CwRouter);

var _TabPanel = require('./TabPanel.scss');

var _TabPanel2 = _interopRequireDefault(_TabPanel);

var _ClickTracker = require('../../services/ClickTracker');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @type {React.StatelessComponent} */
var TabPanel = function TabPanel(props) {
  var onTabSelected = function onTabSelected(id) {
    props.onTabSelected(id);

    // add click track for selected tab
    (0, _ClickTracker.addClickTrack)('tab_' + id);
  };

  var tabs = _react2.default.Children.map(props.children, function (tab) {
    return {
      id: tab.props.id,
      name: tab.props.name
    };
  });

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(props.className, _TabPanel2.default.wrap) },
    _react2.default.createElement(_cwUi.CwTabs, { tabs: tabs, value: props.selectedId, onChange: onTabSelected, isCompact: props.isCompact }),
    _react2.default.createElement(_CwRouter2.default, props)
  );
};

TabPanel.propTypes = {
  selectedId: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.element).isRequired, //Tab
  _propTypes2.default.element.isRequired //Tab
  ]),
  onTabSelected: _propTypes2.default.func.isRequired,
  isCompact: _propTypes2.default.bool
};

exports.default = TabPanel;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/tabpanel/TabPanel.js
// module id = 764
// module chunks = 10